/**
 * VITE_APP_SURFACE_URL — ONB-06 Work onboarding'in Work application
 * origin'inde calismasi icin zorunlu deploy yapilandirmasi.
 */
export function requireAppSurfaceUrl(value: string | undefined): string {
  if (!value?.trim()) {
    throw new Error('VITE_APP_SURFACE_URL tanimli degil: Work application origin\'i zorunludur.')
  }

  let url: URL
  try {
    url = new URL(value)
  } catch {
    throw new Error('VITE_APP_SURFACE_URL gecerli bir mutlak URL olmali.')
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    throw new Error('VITE_APP_SURFACE_URL yalniz http/https origin destekler.')
  }

  if (url.username !== '' || url.password !== '') {
    throw new Error('VITE_APP_SURFACE_URL kimlik bilgisi iceremez.')
  }

  if (url.pathname !== '/' || url.search !== '' || url.hash !== '') {
    throw new Error('VITE_APP_SURFACE_URL yalniz root origin olmali (path/query/hash yasak).')
  }

  return url.origin
}
